import { useAsync } from 'react-use'
import { useWeb3Provider } from '../../components/Web3ContextProvider'
import { CallableContractNames } from '../../types'

/**
 * Returns true if the native currency balance
 * covers the gas fees for a given contract method call.
 *
 * @see https://docs.ethers.io/v5/api/contract/contract/#contract-estimateGas
 * @see https://docs.ethers.io/v5/api/providers/provider/#Provider-getGasPrice
 * @returns native balance > (gas price * estimate units of gas)
 */
export default function useGasFeeCheck(
  contractName?: CallableContractNames,
  methodName?: string,
  ...args: any[]
) {
  const { provider, chainId } = useWeb3Provider()

  return useAsync(async () => {
    if (provider && chainId && contractName && methodName) {
      const [nativeBalance, gasPrice, gasLimit] = await Promise.all([
        provider.getNativeBalance(),
        provider.getGasPriceWei(),
        provider.estimateGasLimit(contractName, methodName, ...args),
      ])
      const estimate = gasPrice.mul(gasLimit)

      return nativeBalance.gt(estimate)
    }
  }, [provider, chainId, contractName, methodName])
}
